module.exports = __webpack_public_path__ + "img/add-coach.894fece9.svg";